import { createMenuItem } from 'utils/navigation/helpers';
import { isAccountSharingReadonlyMode } from 'system/SystemUtil';

const buildOtherMenuSection = ({ userType }) =>
    [
        createMenuItem({
            title: 'trophy_case_badges_heading',
            translationNamespace: 'trophy_case',
            icon: 'badges-new',
            url: '/badges',
            disabled: isAccountSharingReadonlyMode(),
            condition:
                userType.isFitness || userType.isWellness || userType.isDive || userType.isOutdoor || userType.isMarine
        }),
        createMenuItem({
            title: 'personal_records',
            translationNamespace: 'userprofile',
            icon: 'personal-records',
            url: '/personal-records',
            condition: userType.isFitness || userType.isWellness || userType.isDive
        }),
        createMenuItem({
            title: 'goals',
            translationNamespace: 'goals',
            icon: 'goals',
            url: '/goals',
            urlKeyword: 'goal',
            condition: userType.isFitness || userType.isWellness || userType.isDive
        })
    ].flat();

export default buildOtherMenuSection;
